/**
 * Requests to the search bar from elsewhere on the page: put the cursor back
 * into it ("+ Add word", last condition chip removed) or open the search tips
 * (tip line on the landing page). The bar may be portalled into the app bar,
 * so window events avoid passing refs around.
 */

const FOCUS_EVENT = 'enterprise-search:focus-search-bar';
const TIPS_EVENT = 'enterprise-search:open-search-tips';

function subscribe(event: string, handler: () => void): () => void {
  window.addEventListener(event, handler);
  return () => window.removeEventListener(event, handler);
}

export function requestSearchBarFocus(): void {
  window.dispatchEvent(new Event(FOCUS_EVENT));
}

export function onSearchBarFocusRequest(handler: () => void): () => void {
  return subscribe(FOCUS_EVENT, handler);
}

export function requestSearchTips(): void {
  window.dispatchEvent(new Event(TIPS_EVENT));
}

export function onSearchTipsRequest(handler: () => void): () => void {
  return subscribe(TIPS_EVENT, handler);
}
